import { View } from '@react-pdf/renderer';
import React from 'react';
import AdvancesMainHeaderOne from './AdvancesMainHeaderOne';


const AdvancesMainHeader = ({data}) => {
  return (
    <View>
        <AdvancesMainHeaderOne data={data}/>
        {/* <AdvancesMainHeaderTwo data={data}/> */}
    </View>
  )
}

export default AdvancesMainHeader;